<script setup>
import { watch, ref, computed, onMounted } from 'vue'
import axios from 'axios'
import { useModeStore } from '../store/mode.js';
import { useThemeStore } from '../store/theme.js';
// import { useUserStore } from '@/store/user';

const modeStore = useModeStore();
// const userStore = useUserStore();
const themeStore = useThemeStore();
const topics = ref([])
const expandedTopicId = ref(null)  
const selectedArticle = ref(null)
const search = ref('')
const searchResults = ref([])
const showDropdown = ref(false)

onMounted(async () => {
  try {
    const res = await axios.get('/api/v1/help/topics')
    topics.value = res.data
    console.log('Topics response:', res.data)
  } catch (error) {
    console.error('Failed to load topics:', error)
  }
})

const backgroundClass = computed(() => {
  const mode = modeStore.selectedMode;
  const theme = themeStore.selectedTheme;
  return `${mode}-mode-${theme}-bg`;
});

const toggleTopic = (id) => {
  expandedTopicId.value = expandedTopicId.value === id ? null : id
}

// const fetchArticle = async (id) => {
//   try {
//     const res = await axios.get(`/api/v1/help/articles/${id}`)
//     selectedArticle.value = res.data.data || res.data  // depending on your API response structure
//   } catch (error) {
//     console.error('Error loading article:', error)
//   }
// }

const closeArticle = () => {
  selectedArticle.value = null
}

watch(search, (newSearch) => {
  const term = newSearch.toLowerCase().trim()
  if (!term) {
    searchResults.value = []
    return
  }

  const matches = []
  topics.value.forEach(topic => {
    topic.articles.forEach(article => {
      if (article.article_name.toLowerCase().includes(term)) {
        matches.push({ ...article, topicName: topic.topic_name }) 
      }
    })
  })

  searchResults.value = matches
})

const hideDropdown = () => { //timeout for search dropdown
  setTimeout(() => {
    showDropdown.value = false
  }, 200)
}

</script>

<style scoped>
/* For smooth accordion transitions */
.accordion-content {
    transition: max-height 0.3s ease;
    overflow: hidden;
}
</style>

<template>
    <div :class="backgroundClass" class="min-h-screen mx-auto p-6">
        <div class="max-w-5xl mx-auto p-6 justify-center">
            <div class="flex justify-center mb-6">
                <img src="../assets/icons/WelcomePage/delimaflixlogo.svg" alt="DelimaFlix Logo" class="h-16 w-auto" />
            </div>
            <h1 class="text-3xl font-bold mb-2 text-center">Perlukan Bantuan?</h1>
            <p class="text-lg mb-5 text-center">Cari topik berkaitan mengikut peranan anda sebagai pengguna DELIMaFlix.</p>
            <!-- Search Input and Dropdown -->
            <div class="relative max-w-xl mx-auto mb-5">
                <input
                    v-model="search"
                    @focus="showDropdown = searchResults.length > 0"
                    @keydown.esc="showDropdown = false"
                    @blur="hideDropdown"
                    type="text"
                    placeholder="Cari artikel..."
                    class="w-full px-5 py-3 rounded-lg shadow-md border border-gray-300 focus:ring-2 focus:ring-blue-400 focus:outline-none text-white"
                />

                <!-- Search Result Dropdown -->
                <div
                    v-if="searchResults.length > 0 && search.length > 0"
                    class="absolute z-10 w-full bg-white border border-gray-300 mt-2 rounded-lg shadow-lg max-h-80 overflow-auto"
                >
                    <div v-for="article in searchResults" :key="article.id">
                    <router-link
                        :to="`/help/article/${article.id}`"
                        class="block px-5 py-3 hover:bg-blue-50 text-sm text-gray-800 transition"
                        @click="search = ''; searchResults = []"
                    >
                        {{ article.article_name }}
                    </router-link>
                    </div>
                </div>
            </div>
            <div>
                <div v-for="topic in topics" :key="topic.id" class="border border-gray-300 rounded mb-4">
                <!-- Topic Header -->
                <button
                class="w-full flex justify-between items-center px-6 py-4 rounded-lg bg-white hover:bg-blue-50 border-b border-gray-200 transition duration-200 shadow-sm"
                @click="toggleTopic(topic.id)"
                :aria-expanded="expandedTopicId === topic.id"
                >
                    <span class="text-lg font-semibold text-gray-800">{{ topic.topic_name }}</span>
                    <svg
                        class="w-5 h-5 text-gray-500 transition-transform duration-300"
                        :class="{ 'rotate-180': expandedTopicId === topic.id }"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        viewBox="0 0 24 24"
                    >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>
                </button>


                    <!-- Articles List -->
                    <div class="accordion-content px-4" :style="expandedTopicId === topic.id ? 'max-height: 1000px; padding-top: 0.75rem; padding-bottom: 0.75rem;' : 'max-height: 0; padding-top: 0; padding-bottom: 0;'">
                        <ul class="space-y-2">
                            <li
                                v-for="article in topic.articles"
                                :key="article.id"
                            >
                                <router-link
                                :to="`/help/article/${article.id}`"
                                class="block p-3 rounded-lg bg-white hover:bg-blue-50 shadow-sm border border-gray-200 transition duration-200"
                                >
                                <div class="flex items-center space-x-2">
                                    <svg class="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h7" />
                                    </svg>
                                    <span class="text-gray-800 font-medium">{{ article.article_name }}</span>
                                </div>
                                </router-link>
                            </li>
                        </ul>

                    </div>
                </div>
            </div>

            <!-- Article Viewer -->
            <div v-if="selectedArticle" class="mt-8 border border-gray-300 rounded p-6 bg-white shadow">
                <button @click="closeArticle" class="text-blue-600 hover:underline mb-4 inline-flex items-center gap-1">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
                    </svg>
                    Kembali ke topik
                </button>
                <h2 class="text-2xl font-bold mb-3">{{ selectedArticle.article_name }}</h2>
                <div class="prose max-w-none" v-html="selectedArticle.description"></div>
            </div>
        </div>
    </div>
</template>
